






























































































































































































































import { Action, Getter } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";
import { Contractor, Fee, Maintenancejob, SelectOption } from "@/models";
import { DxDateBox } from "devextreme-vue/date-box";
import "devextreme/dist/css/dx.light.css";
import Photos from "@/components/photo/Photos.vue";
@Component({ components: { DxDateBox, Photos } })
export default class extends Vue {
  public index: number = -1;
  public flag: string = "";
  @Getter("maintenancejobs/current") public maintenancejob: Maintenancejob;
  @Action("contractors/getContractors") getContractors: () => Promise<void>;
  public contractorOptions: SelectOption[] = [];
  @Getter("contractors/list") public contractorlist: Contractor[];
  @Action("maintenancejobs/setMaintenancejobDeep")
  public setMaintenancejobDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;

  public async init(index: number, flag: string) {
    this.index = index;
    this.flag = flag;
    await Promise.all([this.getContractors()])
      .then(() => {
        this.setContractorOptions();
      })
      .catch((err: any) => this.$onecentral.displayError(err));
  }

  get name() {
    return (
      this.index != -1 && this.maintenancejob.invoice.fees[this.index].name
    );
  }
  set name(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].name`,
      data,
    });
  }
  public async setContractorOptions() {
    this.contractorOptions = this.contractorlist.map((r) => ({
      slug: r.id,
      name: r.companyName,
    }));
  }

  get locationOptions() {
    return Array.from(
      new Set(
        this.maintenancejob.invoice.fees
          .map((m: Fee) => m.location) // Get the `location` field for each `Fee`
          .filter((location) => location) // Remove falsy values (e.g., null, undefined, empty strings)
      )
    );
  }

  get outnotes() {
    return (
      this.index != -1 && this.maintenancejob.invoice.fees[this.index].outnotes
    );
  }
  set outnotes(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].outnotes`,
      data,
    });
  }

  get insname() {
    return (
      this.index != -1 && this.maintenancejob.invoice.fees[this.index].inspector.id.companyName
    );
  }
  get insnotes() {
    return (
      this.index != -1 &&
      this.maintenancejob.invoice.fees[this.index].inspector.notes
    );
  }
  set insnotes(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].inspector.notes`,
      data,
    });
  }

  get location() {
    return (
      this.index != -1 && this.maintenancejob.invoice.fees[this.index].location
    );
  }
  set location(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].location`,
      data,
    });
  }

  get description() {
    return (
      this.index != -1 &&
      this.maintenancejob.invoice.fees[this.index].description
    );
  }
  set description(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].description`,
      data,
    });
  }

  get completiondate() {
    return (
      this.index != -1 &&
      this.maintenancejob.invoice.fees[this.index].completiondate
    );
  }
  set completiondate(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].completiondate`,
      data,
    });
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].status`,
      data: "Completed",
    });
  }

  get createdate() {
    return (
      this.index != -1 &&
      this.maintenancejob.invoice.fees[this.index].createdate
    );
  }
  set createdate(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].createdate`,
      data,
    });
  }

  get targetdate() {
    return (
      this.index != -1 &&
      this.maintenancejob.invoice.fees[this.index].targetdate
    );
  }
  set targetdate(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].targetdate`,
      data,
    });
  }
  public save() {
    const modal = (this.$parent.$refs.taskmodel as any).$el;
    ($(modal) as any).modal("hide");
  }

  hide() {
    this.index = -1;
    const modal = (this.$parent.$refs.taskmodel as any).$el;
    ($(modal) as any).modal("hide");
  }
  get status() {
    return (
      this.index != -1 && this.maintenancejob.invoice.fees[this.index].status
    );
  }
  set status(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].status`,
      data,
    });
  }
  get inphotos() {
    return (
      this.index != -1 && this.maintenancejob.invoice.fees[this.index].photos.in
    );
  }
  set inphotos(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].photos.in`,
      data,
    });
  }

  get insphotos() {
    return (
      this.index != -1 &&
      this.maintenancejob.invoice.fees[this.index].inspector.photos
    );
  }
  set insphotos(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].inspector.photos`,
      data,
    });
  }

  get outphotos() {
    return (
      this.index != -1 &&
      this.maintenancejob.invoice.fees[this.index].photos.out
    );
  }
  set outphotos(data) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].photos.out`,
      data,
    });
  }
  public statusOptions: string[] = [
    "New",
    "Unallocated",
    "Allocated",
    "In Progress",
    "On Hold",
    "Completed",
  ];
  public clearStatus() {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].status`,
      data: "",
    });
  }

  public setStatus(val: string) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].status`,
      data: val,
    });
  }
  get filterContractors(): SelectOption[] {
    const contractorIds = this.maintenancejob.invoice.fees[this.index]
      ?.contractor;

    if (!contractorIds || !Array.isArray(contractorIds)) {
      return [];
    }

    return this.contractorOptions.filter((r) => contractorIds.includes(r.slug));
  }

  set filterContractors(selectedOptions: SelectOption[]) {
    this.maintenancejob.invoice.fees[
      this.index
    ].contractor = selectedOptions.map((option) => option.slug);
  }

  public onContractorSelect(val: string) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].contractor`,
      data: this.maintenancejob.invoice.fees[this.index]?.contractor.concat(
        val
      ),
    });
    if (this.status === "Unallocated") {
      this.setMaintenancejobDeep({
        path: `invoice.fees[${this.index}].status`,
        data: "Allocated",
      });
    }
  }
  // public onContractorSelect(selected: { value: string; label: string }) {
  //   if (selected !== null) {
  //       this.setMaintenancejobDeep({
  //       path: `invoice.fees[${this.index}].contractor`,
  //       data: selected.value,
  //     });
  //     if(this.status === 'Unallocated'){
  //       this.setMaintenancejobDeep({
  //         path: `invoice.fees[${this.index}].status`,
  //         data: 'Allocated',
  //       });
  //     }
  //   }
  // }
  public clearLocation() {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].location`,
      data: "",
    });
  }
  public addLocation(val: string) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${this.index}].location`,
      data: val,
    });
  }
}
